import * as React from "react";

type LoaderProps = {};

export const Loader: React.FC<LoaderProps> = () => {
  return <div>Loading...</div>;
};
